"use strict";

/**
 * Control zur Verarbeitung von Benachrichtigungen externer Module an das Kartenfenster.
 *
 * @class
 * @extends gc.gis.control.GCAbstractMapControl
 * @memberof gc.gis.control
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen (siehe {@link gc.gis.control.GCAbstractMapControl})
 */
gc.gis.control.GCNotificationManager = function(options)
{
    gc.gis.control.GCAbstractMapControl.call(this, options);

    // TODO als Option übergeben
    this._storageKey = 'gis_webclient_notification';
};
gc.gis.control.GCNotificationManager.prototype = Object.create(gc.gis.control.GCAbstractMapControl.prototype);

/**
 * @inheritdoc
 */
gc.gis.control.GCNotificationManager.prototype.init = function()
{
    var self = this;
    window.addEventListener('storage', function(evt) {
        //	Event ist nur für localStorage verfügbar, daher hier direkt diesen Storage ansprechen
        var notificationData = gc.gis.GCStorage.getItem(self._storageKey, GeoCMS.Storage.StorageType.LOCAL);
        if (notificationData)
        {
            gc.gis.GCStorage.removeItem(self._storageKey);
            self._doHandle(notificationData);
        }
    });
};

/**
 * @inheritdoc
 */
gc.gis.control.GCNotificationManager.prototype.getImpl = function()
{
	return null;
};

/**
 * Verarbeitet eingehende Benachrichtigungen.
 *
 * @private
 * @param {string} notificationData
 */
gc.gis.control.GCNotificationManager.prototype._doHandle = function(notificationData)
{
    var notifications = JSON.parse(notificationData);
    var params;

    for (var i=0; i<notifications.length; i++)
    {
        params = notifications[i].params;
        switch (notifications[i].method)
        {
            case 'center':
                this._map.panTo([params.x, params.y], params.crs);
                if (params.text)
                {
                    this._map.showMarker(params.text, [params.x, params.y], {
                    	projection: params.crs
                    });
                }
                break;

	        case 'centerUrl':
		        this._doProcessByUrl(params.request, false, false, true);
	        	break;

            case 'zoom':
                var format = gc.gis.iface.mapFactory.createFormat();
                var geom = format.readGeometry(params.geometry, params.format, params.crs);
                this._map.fitGeometry(geom, {
                    constrain_resolution: true,
                    minscale: Math.min(this._map.getScale(), gc.gis.iface.ZOOM_TO_MINSCALE)
                });
                break;

	        case 'zoomUrl':
		        this._doProcessByUrl(params.request, false, true, false);
		        break;

            case 'highlight':
	            this._doHighlightGeometry(params.geometry, params.format, params.crs, params.text, true);
                break;

	        case 'highlightList':
		        for (var j=0; j<params.geometryList.length; j++)
		        {
			        this._doHighlightGeometry(
			        	params.geometryList[j],
				        params.formatList[j],
				        params.crsList[j],
				        params.textList[j],
				        j === 0
			        );
		        }
	        	break;

	        case 'highlightUrl':
	            this._doProcessByUrl(params.request, true, params.action === 'zoom', params.action === 'center');
	            break;

	        case 'highlightReset':
	        	this._map.clearHighlighting();
	        	break;
        }
    }
};

gc.gis.control.GCNotificationManager.prototype._doHighlightGeometry = function(geometry, format, crs, text, clear)
{
	if (text && text.toString().length > 0)
	{
		this._map.highlightGeometryWithMarker(
			geometry,
			format,
			text.toString(),
			{
				projection: crs,
				clear: clear
			}
		);
	}
	else
	{
		this._map.highlightGeometry(
			geometry,
			format,
			{
				projection: crs,
				clear: clear
			}
		);
	}
};

gc.gis.control.GCNotificationManager.prototype._doProcessByUrl = function(request, highlight, zoom, center)
{
    var self = this;
    if (request)
    {
	    gc.gis.iface.request.ajax({
            lable: 'Lade Daten zur Anzeige...',
		    url: request,
		    dataType: gc.gis.util.GCRequestManagerDataType.JSON,
		    success: function (data) {
                // Objekte hervorheben
		        if (highlight === true && data.features)
                {
	                for (var i=0; i<data.features.length; i++)
                    {
                    	if (data.features[i].title && data.features[i].title.toString().length > 0)
	                    {
		                    self._map.highlightGeometryWithMarker(
			                    data.features[i].geom,
			                    data.features[i].format,
			                    data.features[i].title.toString(),
			                    {
				                    projection: data.features[i].crs,
				                    clear: i===0
			                    }
		                    );
	                    }
	                    else
	                    {
		                    self._map.highlightGeometry(
			                    data.features[i].geom,
			                    data.features[i].format,
			                    {
				                    projection: data.features[i].crs,
				                    clear: i===0
			                    }
		                    );
	                    }
                    }
                }

                // zoomen
		        if (zoom && data.extent)
                {
	                var format = gc.gis.iface.mapFactory.createFormat();
	                var geom = format.readGeometry(data.extent.geom, data.extent.format, data.extent.crs);

	                self._map.fitGeometry(geom, {
	                   constrain_resolution: true,
	                   minscale: Math.min(self._map.getScale(), gc.gis.iface.ZOOM_TO_MINSCALE)
	                });
                }
                // zentrieren
                else if (center && data.location)
                {
                    self._map.panTo([data.location.x, data.location.y], data.location.crs);
                }
		    },
            error: function (error) {
	            gc.gis.iface.log.error(self, 'Fehler beim Laden der Daten für die Anzeige von Objekten.');
            }
	    });
    }
    else
    {
	    gc.gis.iface.log.error(self, 'Ungültige Benachrichtigung zum Anzeigen von Objekten empfangen.');
    }
};
